export default __webpack_public_path__ + "static/product-hero-1-4b7d2efb96bef50e7f8a245a23493754.webp";